import { NgModule } from '@angular/core';
import { IncludePipe } from './includepipe';

@NgModule({
  declarations: [
    IncludePipe,
  ],
  imports: [
    
  ],
  exports: [
    IncludePipe
  ]
})
export class IncludePipeModule {}
